// Helpers to filter a list by created_at against preset ranges.

const startOfMonth = (d) => new Date(d.getFullYear(), d.getMonth(), 1);
const endOfMonth = (d) => new Date(d.getFullYear(), d.getMonth() + 1, 1);
const startOfQuarter = (d) => new Date(d.getFullYear(), Math.floor(d.getMonth() / 3) * 3, 1);
const endOfQuarter = (d) => new Date(d.getFullYear(), Math.floor(d.getMonth() / 3) * 3 + 3, 1);
const startOfYear = (d) => new Date(d.getFullYear(), 0, 1);
const endOfYear = (d) => new Date(d.getFullYear() + 1, 0, 1);
const addMonths = (d, n) => new Date(d.getFullYear(), d.getMonth() + n, 1);

export const RANGE_OPTIONS = [
  { id: 'all', label: 'all time' },
  { id: 'this_month', label: 'this month' },
  { id: 'last_month', label: 'last month' },
  { id: 'this_quarter', label: 'this quarter' },
  { id: 'last_quarter', label: 'last quarter' },
  { id: 'this_year', label: 'this year' },
  { id: 'last_year', label: 'last year' },
];

// Also expose a per-month picker (jan..dec of the current year)
export const monthOptionsForYear = (year = new Date().getFullYear()) => {
  const names = ['January','February','March','April','May','June','July','August','September','October','November','December'];
  return names.map((n, i) => ({ id: `m_${year}_${i}`, label: `${n} ${year}`, year, month: i }));
};

export const rangeForOption = (id) => {
  const now = new Date();
  if (id === 'all') return null;
  if (id === 'this_month') return { start: startOfMonth(now), end: endOfMonth(now) };
  if (id === 'last_month') return { start: addMonths(startOfMonth(now), -1), end: startOfMonth(now) };
  if (id === 'this_quarter') return { start: startOfQuarter(now), end: endOfQuarter(now) };
  if (id === 'last_quarter') {
    const s = startOfQuarter(now);
    return { start: new Date(s.getFullYear(), s.getMonth() - 3, 1), end: s };
  }
  if (id === 'this_year') return { start: startOfYear(now), end: endOfYear(now) };
  if (id === 'last_year') return { start: new Date(now.getFullYear() - 1, 0, 1), end: startOfYear(now) };
  if (id?.startsWith?.('m_')) {
    const [, y, m] = id.split('_').map(Number);
    return { start: new Date(y, m, 1), end: new Date(y, m + 1, 1) };
  }
  return null;
};

// Filter items with a date field (e.g. 'created_at') that is a Date/ISO string.
export const filterByRange = (items, rangeId, field = 'created_at') => {
  const range = rangeForOption(rangeId);
  if (!range) return items;
  return items.filter((it) => {
    const raw = it?.[field];
    if (!raw) return false;
    const d = new Date(raw);
    return d >= range.start && d < range.end;
  });
};
